module.exports = __webpack_public_path__ + "img/AT0000002407458.0a8090f0.png";